import { useEffect, useState } from "react";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchMonthSingleForm } from "src/components/common/form/search/SearchMonthSingleForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { formatDateMonth, formatDateYear4 } from "src/utils/string/stringUtil";
import { useEQM2070_R01Store } from "./Store_EQM2070_R01";

export const SearchSection_EQM2070_R01 = () => {
	const { compCdList} = useCommonCodeStore();
	const { EQM2070_R01Filter, setEQM2070_R01Filter } = useEQM2070_R01Store();

	const [pickerVisible, setPickerVisible] = useState(false);
	const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({
		top: 0,
		left: 0,
	});

	useEffect(() => {
		if (compCdList.length > 0 && !EQM2070_R01Filter.compCd) {
			setEQM2070_R01Filter({ compCd: compCdList[0].compCd });
		}
	}, [compCdList, EQM2070_R01Filter.compCd, setEQM2070_R01Filter]);
    //
	// useEffect(() => {
	// 	const platingItem = eqmTypeList.find(
	// 		(item) => item.minorCd === EQM2070_R01Filter.equipmentCd,
	// 	);
	// 	if (platingItem && EQM2070_R01Filter.equipmentNm !== platingItem.codeNm) {
	// 		setEQM2070_R01Filter({ equipmentNm: platingItem.codeNm });
	// 	}
	// }, [eqmTypeList, EQM2070_R01Filter.equipmentCd, EQM2070_R01Filter.equipmentNm, setEQM2070_R01Filter]);

	return (
		<SearchSectionForm>
			<SearchDropDownForm
				label="사업장"
				value={EQM2070_R01Filter.compCd}
				optionList={compCdList}
				onChangeItem={(selectedItem) =>
					setEQM2070_R01Filter({ compCd: selectedItem?.compCd || "" })
				}
				initLabelLess={true}
			/>
			<SearchMonthSingleForm
				label="점검년월"
				visible={pickerVisible}
				setVisible={setPickerVisible}
				value={new Date(EQM2070_R01Filter.inspectDt)}
				editable={true}
				onChange={(date) =>
					setEQM2070_R01Filter({
						inspectDt: formatDateYear4(date) + "-" + formatDateMonth(date),
					})
				}
				pickerPosition={pickerPosition}
				setPickerPosition={setPickerPosition}
			/>
			{/*<SearchDropDownForm*/}
			{/*	label="설비코드"*/}
			{/*	value={EQM2070_R01Filter.equipmentCd}*/}
			{/*	optionList={eqmTypeList}*/}
			{/*	editable={false}*/}
			{/*	wrapperOption={{*/}
			{/*		wrapperStyle: "w-[200px] min-w-[200px] mr-[10px]",*/}
			{/*		titleStyle: "w-[60px] min-w-[60px] text-left",*/}
			{/*		selectStyle: "w-[135px] min-w-[135px]",*/}
			{/*	}}*/}
			{/*/>*/}
		</SearchSectionForm>
	);
};